export const SET_COUNTY_DETAILS_REQUEST_STATUS = 'SET_COUNTY_DETAILS_REQUEST_STATUS'
export const SET_COUNTY_DETAILS = 'SET_COUNTY_DETAILS'